import { useQuery } from '@tanstack/react-query';
import { meQuery } from './queries.ts';

/** The player's state plus clock skew (server − client) for display countdowns. */
export function useMe() {
  const q = useQuery(meQuery());
  const skew = q.data?.player ? q.data.player.serverTime - q.dataUpdatedAt : 0;
  return { ...q, skew };
}
